import React, { useState } from 'react';
import styles from './styles.module.scss';

import { ReactComponent as ArrowDown } from '../../../assets/icons/icon-arrow-down.svg';
import { spanish } from '../../../config/config';

const TelSelector = ({
  id,
  title,
  value,
  placeholder,
  options,
  required,
  onChange,
}) => {
  const errorMessage = spanish
    ? 'Este campo es requerido'
    : 'This field is required';
  const [error, setError] = useState(false);
  const validateInput = (e) => {
    if (required && e.currentTarget.value === '') setError(true);
    else setError(false);
  };
  return (
    <div className={styles.container}>
      {title !== undefined ? <p className={styles.title}>{title}</p> : ''}
      <label>
        <select
          id={id}
          className={error ? 'error' : ''}
          value={value}
          required={required}
          onChange={onChange}
          onBlur={validateInput}
        >
          <option value="">{placeholder}</option>
          {options?.map((option) => (
            <option value={option} key={option}>
              {option}
            </option>
          ))}
        </select>
      </label>
      <ArrowDown />
      <p className={styles.error}>{error ? errorMessage : ''}</p>
    </div>
  );
};

export default TelSelector;
